jQuery(document).ready( function($) {

    /*$('.c-hamburger').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('nav-panels--open');

        if ($('.c-hamburger').css('display') !== 'none') { //hamburger is visible
            $('.nav-panel').css('transition', 'transform .5s');
        } else {
            $('.nav-panel').css('transition', 'none');
        }
    });*/

    $('.banner .scrolldown').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            let y = parseInt($('.banner').css('height'));
            $('html,body').animate({scrollTop: y}, 600);
        }, 100);
    });


    $('.nav-btn').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('menu-open');
    });

    $('#back-to-top').click(function(){
        $('body,html').animate({
            scrollTop: 0
        }, 300);
        return false;
    });

    $('ul.team-members li').on('click', function(e) {
        e.preventDefault();
        if ( !$(this).hasClass('on') ) {
            $('ul.team-members li').removeClass('on');
            $(this).addClass('on');
        }
    });

    $('#superspace-btn').click( function(e){
        e.preventDefault();
        setTimeout(function(){
            let y = parseInt($('.video-panel').css('height'));
            $('html,body').animate({scrollTop: y}, 1200);
        }, 100);
    });

    function stickynav() {
        let scrolltop = $(window).scrollTop(); //current vertical position from the top
        if (scrolltop > 150) {
            $('body').addClass('sticky');
        } else {
            $('body').removeClass('sticky');
        }
    }
    stickynav();

    $(window).scroll(function() {
        stickynav();
    });

    // init Masonry
    let $masonrygrid = $('.masonry').masonry({
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });

    // layout Masonry after each image loads
    $masonrygrid.imagesLoaded().progress( function() {
        $masonrygrid.masonry('layout');
    });


    $('#projectlist .project-item').on('click', function(e) {
        e.preventDefault();

        let _this = $(this);
        let _parent = _this.closest('.project-row');
        let _details = _parent.find('.project-details');
        let _content = _parent.find('.project-details-wrap');
        let _header = _this.find('div');
        let _height = _content.height();

        if (_parent.hasClass('project-open') === false) { //open project

            /* closes each item - not recommended due to jumps?? */
            $('.project-row').removeClass('project-open');
            $('.project-row').removeClass('project-opened');
            $('.project-item').removeClass('project-open');
            $('.project-details-wrap').css('opacity', 0);
            $('.project-details').css('height', 0);


            _parent.addClass('project-open');
            _this.addClass('project-open');

            jQuery.easing.def = 'easeInCubic';
            _details.animate({ height:_height }, 500, function(){ //'easeInCubic',
                //Scroll.doResize();
                _details.height('auto');
                _parent.addClass('project-opened');
                jQuery.easing.def = 'linear';
                _content.animate({ opacity:1 }, 400);
            });

        } else { // close project

            _parent.removeClass('project-open');
            _parent.removeClass('project-opened');
            _this.removeClass('project-open');
            _details.height(_height);

            jQuery.easing.def = 'linear';
            _content.animate({ opacity:0 }, 400, function() {
                jQuery.easing.def = 'easeInCubic';
                _details.animate({ height:0 }, 500, function() {
                    //Scroll.doResize();
                    _content.css('opacity', 1);
                });
            });

        }
    });


    let _sort = { projects:[] };
    $('#projectlist .project-row').each( function(index) {
        _sort.projects[index] = [];
        _sort.projects[index].id = $(this).attr('id');
        _sort.projects[index].brand = $(this).data('brand');
        _sort.projects[index].years = $(this).data('years');
        _sort.projects[index].type = $(this).data('type');
        _sort.projects[index].location = $(this).data('location');
    });

    function sortASC(col) {
        if (_sort.projects !== null) {
            _sort.projects.sort(function(a, b) {
                if (a[col] < b[col]) return -1;
                if (a[col] > b[col]) return 1;
                return 0;
            });
        }
    }
    function sortDSC(col) {
        if (_sort.projects !== null) {
            _sort.projects.sort(function(a, b) {
                if (a[col] > b[col]) return -1;
                if (a[col] < b[col]) return 1;
                return 0;
            });
        }
    }
    function reorderProjects() {
        if (_sort.projects !== null) {
            for (let i=0; i<_sort.projects.length; i++) {
                $('#projectlist').append( $('#'+_sort.projects[i].id) );
            }
        }
    }

    $('select#projectsel').on('change', function(e) {
        let val = e.target.value;
        $('.sort-link').removeClass('active-desc');
        $('.sort-link').removeClass('active-asc');
        $('.sort-link.sort-'+val).addClass('active-asc');
        sortASC( val );
        reorderProjects();
    });

    $('.table-head .sort-link').on('click', function(e) {

        e.preventDefault();
        if ($(this).hasClass('active-asc')) {
            $(this).removeClass('active-asc');
            $(this).addClass('active-desc');
            sortDSC($(this).data('order'));

        } else if ($(this).hasClass('active-desc')) {
            $(this).removeClass('active-desc');
            $(this).addClass('active-asc');
            sortASC($(this).data('order'));

        } else {
            $('.table-head .sort-link').removeClass('active-asc');
            $('.table-head .sort-link').removeClass('active-desc');
            $(this).addClass('active-asc');
            sortASC($(this).data('order'));
        }
        reorderProjects();
        $('select#projectsel').val( $(this).data('order') );

    });

    function doresize() {
        $('body').removeClass('nav-panels--open');
        if ($('.c-hamburger').css('display') !== 'none') { //hamburger is visible
            $('.nav-panel').css('transition', 'transform .5s');
        } else {
            $('.nav-panel').css('transition', 'none');
        }
    }

    doresize();
    window.onresize = doresize;

    $('.gallery-carousel').flickity({
        cellSelector: '.carousel-cell',
        contain: true,
        pageDots: false,
        imagesLoaded: true,
        //arrowShape: 'M9 3l9 9-9 9',
    });

    //Prevent all fancybox from showing the thumbnails navbar:
    Fancybox.bind('[data-fancybox]', {
        Thumbs: {
            autoStart: false,
        },
    });

    /* $('.vid').hover(function toggleControls() {
        if (this.hasAttribute("controls")) {
            this.setAttribute("controls", "controls");
        } else {
            this.removeAttribute("controls");
        }
    }); */

    function popupsubscribe() {
        jQuery.fancybox({
            'autoScale': true,
            'transitionIn': 'elastic',
            'transitionOut': 'elastic',
            'speedIn': 500,
            'speedOut': 300,
            'autoDimensions': true,
            'centerOnScroll': true,
            'href': '#subscribe_popup'
        });
    }
    $('.btn-subscribe').on('click', function(e) {
        popupsubscribe();
    });

});
